export default $ => {
  const maps = $('[data-maps]');


  if (maps.length > 0) {
    maps.each(function () {
      const self = $(this);
      const position = {
        lat: self.data('maps-latitude'),
        lng: self.data('maps-longitude'),
      };
      const map = window.L.map(self.get(0), {
        center: [position.lat, position.lng],
        zoom: 12,
        minZoom: 0,
        scrollWheelZoom: false,
      });

      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);
      const marker = window.L.marker([position.lat, position.lng]).addTo(map);
    });
  }
};



// WEBPACK FOOTER //
// ./assets/js/component/maps.js